import Vue from "vue";
Vue.filter("removepack", function(item)
{
    const replaced = item.split("-PACK");

    return replaced[0];
});
